export enum EnquiryStatus {
  NEW = "NEW",
  QUOTED = "QUOTED",
  CONVERTED = "CONVERTED",
  CANCELLED = "CANCELLED",
}

export enum EnquiryIntent {
  SERVICE = "SERVICE",
  AMC = "AMC",
  MATERIAL = "MATERIAL",
}

export const EnquiryIntentLabelMap: Record<EnquiryIntent, string> = {
  [EnquiryIntent.SERVICE]: "Service",
  [EnquiryIntent.AMC]: "AMC",
  [EnquiryIntent.MATERIAL]: "Material",
};

/** Shown as tooltip on status badges (listing & overview). */
export const enquiryStatusMap = {
  [EnquiryStatus.NEW]: {
    label: "New",
    color: "primary",
    hint: "Enquiry has been recorded. An owner may be assigned while the enquiry is in this status.",
  },
  [EnquiryStatus.QUOTED]: {
    label: "Quoted",
    color: "warning",
    hint: "Quotation has been shared with the customer and approval is pending",
  },
  [EnquiryStatus.CONVERTED]: {
    label: "Converted",
    color: "secondary",
    hint: "Converted to a Work order/AMC.",
  },
  [EnquiryStatus.CANCELLED]: {
    label: "Cancelled",
    color: "danger",
    hint: "Enquiry was cancelled or marked invalid and will not proceed.",
  },
};
